import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import ReactHtmlParser from 'react-html-parser';
import Wentwrong from '../Wentwrong/Wentwrong';
import { FaCalendarAlt, FaMapMarkerAlt, FaArrowRight, FaHandHoldingHeart, FaRegCalendarTimes } from 'react-icons/fa';
import { motion } from 'framer-motion';

const cardVariants = {
    hidden: { opacity: 0, y: 36 },
    visible: i => ({
        opacity: 1, y: 0,
        transition: { duration: 0.48, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }
    })
};

const headerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.12 } }
};

const headerItem = {
    hidden: { opacity: 0, y: 22 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } }
};

class Allevent extends Component {
    constructor() {
        super();
        this.state = {
            myData: [],
            error: false,
            loading: true,
        };
    }

    componentDidMount() {
        IRestClient.GetRequest(AppUrl.allevents).then(result => {
            if (result == null) {
                this.setState({ error: true, loading: false });
            } else {
                this.setState({ myData: result, loading: false });
            }
        }).catch(() => this.setState({ error: true, loading: false }));
    }

    getCountdownBadge = (dateStr) => {
        if (!dateStr) return null;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const eventDate = new Date(dateStr);
        eventDate.setHours(0, 0, 0, 0);
        const diffDays = Math.round((eventDate - today) / (1000 * 60 * 60 * 24));

        if (diffDays === 0) return { label: 'Today!', classes: 'bg-green-500 text-white' };
        if (diffDays === 1) return { label: 'Tomorrow', classes: 'bg-blue-500 text-white' };
        if (diffDays <= 7) return { label: `In ${diffDays} days`, classes: 'bg-accent-600 text-white' };
        if (diffDays <= 30) return { label: `In ${diffDays} days`, classes: 'bg-primary-700 text-white' };
        return null;
    };

    render() {
        if (this.state.loading) {
            return (
                <section className="py-20 bg-white">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        {/* Header skeleton */}
                        <div className="text-center mb-14">
                            <div className="skel h-7 w-44 rounded-full mx-auto mb-5" />
                            <div className="skel h-12 w-80 rounded-xl mx-auto mb-3" />
                            <div className="skel h-12 w-64 rounded-xl mx-auto mb-5" />
                            <div className="skel h-1 w-24 rounded-full mx-auto mb-6" />
                            <div className="skel h-4 w-96 rounded mx-auto mb-2" />
                            <div className="skel h-4 w-72 rounded mx-auto" />
                        </div>
                        {/* Cards skeleton */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {[1, 2, 3, 4, 5, 6].map(i => (
                                <div key={i} className="rounded-2xl overflow-hidden border border-neutral-100" style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.06)' }}>
                                    <div className="skel w-full" style={{ height: '14rem', borderRadius: 0 }} />
                                    <div className="p-6">
                                        <div className="flex gap-4 mb-4">
                                            <div className="skel h-4 w-24 rounded" />
                                            <div className="skel h-4 w-28 rounded" />
                                        </div>
                                        <div className="skel h-5 w-full rounded mb-2" />
                                        <div className="skel h-5 w-3/4 rounded mb-5" />
                                        <div className="skel h-3 w-full rounded mb-2" />
                                        <div className="skel h-3 w-full rounded mb-2" />
                                        <div className="skel h-3 w-2/3 rounded mb-6" />
                                        <div className="skel h-9 w-32 rounded-xl" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            );
        }
        if (this.state.error) return <Wentwrong />;

        const { myData } = this.state;

        return (
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    {/* Section Header */}
                    <motion.div
                        className="text-center mb-14"
                        variants={headerVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        <motion.span
                            className="inline-flex items-center gap-2 bg-accent-100 text-accent-700 text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-4"
                            variants={headerItem}
                        >
                            <FaHandHoldingHeart />
                            Events &amp; Activities
                        </motion.span>

                        <motion.h1
                            className="text-4xl md:text-5xl lg:text-6xl font-black text-primary-900 mb-5 leading-tight"
                            variants={headerItem}
                        >
                            Upcoming{' '}
                            <span className="text-secondary-600">Charity Events</span>
                        </motion.h1>

                        <motion.div
                            className="h-1 bg-secondary-500 rounded-full mx-auto mb-6"
                            style={{ width: 0 }}
                            animate={{ width: '6rem' }}
                            transition={{ duration: 0.8, delay: 0.45 }}
                        />

                        <motion.p
                            className="text-lg md:text-xl text-neutral-500 max-w-3xl mx-auto leading-relaxed"
                            variants={headerItem}
                        >
                            {myData.length > 0
                                ? `${myData.length} upcoming event${myData.length > 1 ? 's' : ''} — join us and help make a difference.`
                                : 'From fundraisers to community outreach, stay tuned for our next events.'}
                        </motion.p>
                    </motion.div>

                    {/* Empty State */}
                    {myData.length === 0 ? (
                        <motion.div
                            className="flex flex-col items-center justify-center py-24 px-4"
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className="bg-neutral-50 border border-neutral-100 rounded-3xl p-12 max-w-md w-full text-center shadow-sm">
                                <div className="flex items-center justify-center w-20 h-20 bg-accent-100 rounded-full mx-auto mb-6">
                                    <FaRegCalendarTimes className="text-4xl text-accent-500" />
                                </div>
                                <h2 className="text-2xl font-bold text-primary-900 mb-3">
                                    No Upcoming Events
                                </h2>
                                <p className="text-neutral-500 text-sm leading-relaxed mb-8">
                                    We don't have any events scheduled at the moment. Check back soon — we're always planning something meaningful for the community.
                                </p>
                                <Link
                                    to="/"
                                    className="inline-flex items-center gap-2 bg-primary-800 hover:bg-primary-900 text-white font-semibold py-3 px-7 rounded-xl transition-all duration-300 text-sm shadow-md hover:shadow-lg"
                                >
                                    Back to Home
                                    <FaArrowRight className="text-xs" />
                                </Link>
                            </div>
                        </motion.div>
                    ) : (
                        /* Events Grid */
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {myData.map((event, index) => {
                                const countdown = this.getCountdownBadge(event.date);
                                return (
                                    <motion.div
                                        key={event.id}
                                        className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-400 overflow-hidden border border-neutral-100"
                                        custom={index}
                                        variants={cardVariants}
                                        initial="hidden"
                                        whileInView="visible"
                                        viewport={{ once: true, amount: 0.15 }}
                                        whileHover={{ y: -6, transition: { duration: 0.25, ease: 'easeOut' } }}
                                        onClick={() => this.props.history.push(`/eventdetails/${event.id}/${event.event_title}`)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {/* Image */}
                                        <div className="relative h-56 overflow-hidden">
                                            <img
                                                src={event.event_image}
                                                alt={event.event_title}
                                                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

                                            {/* Countdown badge — top-right */}
                                            {countdown ? (
                                                <div className={`absolute top-3 right-3 text-xs font-bold px-3 py-1 rounded-full shadow-lg ${countdown.classes}`}>
                                                    {countdown.label}
                                                </div>
                                            ) : (
                                                <div className="absolute top-3 right-3 bg-white/95 text-primary-800 text-xs font-semibold px-3 py-1.5 rounded-full border border-neutral-100 shadow-sm">
                                                    Upcoming
                                                </div>
                                            )}
                                        </div>

                                        {/* Content */}
                                        <div className="p-6">
                                            {/* Meta row */}
                                            <div className="flex items-center gap-5 mb-4 text-sm text-neutral-500">
                                                <span className="flex items-center gap-1.5">
                                                    <FaCalendarAlt className="text-secondary-600 flex-shrink-0" />
                                                    {event.date
                                                        ? new Date(event.date).toLocaleDateString('en-US', {
                                                            month: 'short', day: 'numeric', year: 'numeric'
                                                          })
                                                        : 'Date TBD'}
                                                </span>
                                                <span className="flex items-center gap-1.5 truncate">
                                                    <FaMapMarkerAlt className="text-secondary-600 flex-shrink-0" />
                                                    <span className="truncate">{event.event_location || 'Location TBD'}</span>
                                                </span>
                                            </div>

                                            {/* Title */}
                                            <h3 className="text-lg font-bold text-primary-900 mb-3 leading-snug group-hover:text-secondary-600 transition-colors duration-300 line-clamp-2">
                                                <Link
                                                    to={`/eventdetails/${event.id}/${event.event_title}`}
                                                    className="hover:text-secondary-600 transition-colors duration-300"
                                                    onClick={e => e.stopPropagation()}
                                                >
                                                    {event.event_title}
                                                </Link>
                                            </h3>

                                            {/* Description */}
                                            <p className="text-sm text-neutral-500 leading-relaxed mb-5 line-clamp-3">
                                                {ReactHtmlParser(
                                                    event.event_description
                                                        ? event.event_description.substring(0, 130) + (event.event_description.length > 130 ? '...' : '')
                                                        : 'No description available.'
                                                )}
                                            </p>

                                            {/* CTA */}
                                            <Link
                                                to={`/eventdetails/${event.id}/${event.event_title}`}
                                                className="inline-flex items-center gap-2 bg-primary-700 hover:bg-primary-800 text-white font-semibold text-sm px-5 py-2.5 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg"
                                                onClick={e => e.stopPropagation()}
                                            >
                                                Discover More
                                                <FaArrowRight className="text-xs transition-transform duration-300 group-hover:translate-x-1" />
                                            </Link>
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </section>
        );
    }
}

export default withRouter(Allevent);
